import { useAccountStore } from '@/stores/account.js';
import { defineChannelAccountStore } from '@/stores/channelAccount.js';

// The eBay account the /ebay/* analytics pages read. Rows come from the integration
// service's connections list (id, username, registration marketplace, status — never the
// eBay user id); the id travels to olap as the Ebayaccountid header.
//
// Only ACTIVE accounts are offered: olap answers a non-ACTIVE account like another
// tenant's (403), because there is no access without an active connection. Disconnected
// and revoked accounts stay visible, with Reconnect, on Settings > eBay.
export const isReadableEbayAccount = (account) => account?.status === 'ACTIVE';

export const fetchReadableEbayAccounts = async () =>
  ((await useAccountStore().fetchEbayConnections()) || []).filter(isReadableEbayAccount);

export const useEbayAccountStore = defineChannelAccountStore('ebayAccount', {
  storagePrefix: 'wp.ebay.selectedAccount',
  fetchAccounts: fetchReadableEbayAccounts,
});
